import Basics from './BasicsFormularies'
import EvaluateContext from './ToCEvaluateContextFormularies'
import PushAndPullFactors from './ToCPushANdPullFactorsFormularies'

import RiskAndResilience from './ToCRiskAndResilienceFormularies'
import TheoryOfChange from './ToCFormularies'
import GoalsAndObjectives from './GoalsAndObjectivesFormularies'
import Activities from './ActivitiesFormularies'
import GoalsAndActivities from './GaAFormularies'
import Indicators from './IndicatorsFormularies'
import DataCollectionMethods from './CollectionMethodsFormularies'
import ResourcesAndLimitations from './ResourcesAndLimitationsFormularies'
import ProjectingResults from './ProjectingResultsFormularies'
import EvaluatingResults from './EvaluatingResultsFormularies'
import ActualMap from './ActualMapFormularies'
import ActualResults from './ActualResultsFormularies'
import Resources from './Resources'
import IndicatorGenerator from './IndicatorGeneratorFormularies'


export {
    Basics, EvaluateContext,
    PushAndPullFactors, RiskAndResilience,
    TheoryOfChange, GoalsAndObjectives,
    Activities, GoalsAndActivities,
    Indicators, DataCollectionMethods,
    ResourcesAndLimitations, ProjectingResults,
    EvaluatingResults, ActualMap, ActualResults, Resources,
    IndicatorGenerator
};


// WEBPACK FOOTER //
// ./src/routers/Projects/Formularies/index.js